export const ABRE_CUENTAS_ORIGIN = 'abrecuentas';

/**
 * Constante de lista de actividad económica
 *
 * *Economical activity list constants*
 */
export const CIIU_LIST = [
  {
    sector_code: 0,
    ciiu: 10,
    description: 'ASALARIADOS: PERSONAS NATURALES Y SUCESIONES ILÍQU',
  },
  {
    sector_code: 0,
    ciiu: 81,
    description: 'SIN ACTIVIDAD ECONOMICA',
  },
  {
    sector_code: 0,
    ciiu: 82,
    description: 'PERSONAS NATURALES SUBSIDIADAS POR TERCEROS',
  },
  {
    sector_code: 0,
    ciiu: 90,
    description: 'RENTISTAS DE CAPITAL SOLO PARA PERSONAS NATURALES.',
  },
];

/**
 * Constante de lista de típos de contratos
 *
 * *Contracts type list constants*
 */
export const CONTRACTS_LIST = [
  {
    label: 'término indefinido',
    elementId: 2,
    checked: false,
    message: '* debes llevar con este contrato mínimo 6 meses',
    timeText: '6 meses',
    timeMin: 0,
  },
  {
    label: 'término fijo',
    elementId: 1,
    checked: false,
    message: '* debes llevar con este contrato mínimo 1 año',
    timeText: '1 año',
    timeMin: 0,
  },
  {
    label: 'prestación de servicios',
    elementId: 3,
    checked: false,
    message: '* debes llevar con este contrato mínimo 2 años',
    timeText: '2 años',
    timeMin: 0,
  },
];

/**
 * Constante de ERROR_111, error de captura de foto
 *
 * *Error_111 constant, Error while taking photo*
 */
export const ERROR_111 = {
  CODE: '111',
  DATA: {
    type: 'error',
    title: 'No fue posible tomar la foto. <br/>Te recomendamos:',
    description: [
      'Busca un lugar con buena iluminación.',
      'Verifica que tu cédula y el marco guía estén alineados.',
      'Inclina tu cédula para evitar el reflejo de la luz.',
      'Toca la pantalla para enfocar y mantén quieto el celular.',
    ],
    buttonLabel: 'Reintentar',
    buttonAction: '$next',
  },
};

/**
 * Constante de ERROR_112, error de captura de foto
 *
 * *Error_112 constant, Error while taking photo*
 */
export const ERROR_112 = {
  CODE: '112',
  DATA: {
    type: 'error',
    title: 'No fue posible tomar la foto. <br/>Te recomendamos:',
    description: [
      'Busca un lugar con buena iluminación.',
      'Verifica que tu cédula y el marco guía estén alineados.',
      'Inclina tu cédula para evitar el reflejo de la luz.',
      'Toca la pantalla para enfocar y mantén quieto el celular.',
    ],
    buttonLabel: 'Reintentar',
    buttonAction: '$next',
  },
};

/**
 * Constante de ERROR_113, error de captura de foto
 *
 * *Error_113 constant, Error while taking photo*
 */
export const ERROR_113 = {
  CODE: '113',
  DATA: {
    type: 'error',
    title: 'No fue posible tomar la foto. <br/>Te recomendamos:',
    description: [
      'Busca un lugar con buena iluminación.',
      'Separa tus dedos y ubícalos dentro de los recuadros que aparecen en la pantalla.',
      'Mantén tus dedos quietos, la captura de tus huellas se hará de forma automática.',
      'Para mejorar el enfoque, es posible que la luz de tu cámara se prenda y apague.',
    ],
    buttonLabel: 'Reintentar',
    buttonAction: '$next',
  },
};

/**
 * Constante de ERROR_102, Error en la validación de identidad
 *
 * *Error_102 constant, Error validating identity*
 */
export const ERROR_102 = {
  CODE: '102',
  DATA: {
    type: 'error',
    title: '¡Lo sentimos! No fue posible validar tu identidad',
    description: 'Te invitamos a continuar este proceso en una de nuestras sucursales.',
    showLinkOffices: true,
    buttonLabel: 'Finalizar',
    buttonAction: '$exit',
  },
};

/**
 * Constante de ERROR_103, Error en el escaneo del documento
 *
 * *Error_103 constant, Error scanning document*
 */
export const ERROR_103 = {
  CODE: '103',
  DATA: {
    type: 'error',
    title: 'No es posible continuar',
    description: `El documento que intentas escanear no es v\u00E1lido,
    te invitamos a continuar con este proceso en una de nuestras sucursales.`,
    showLinkOffices: true,
    buttonLabel: 'Finalizar',
    buttonAction: '$exit',
  },
};

/**
 * Constante de ERROR_104, Error en la ejecución del evento
 *
 * *Error_104 constant, Error on app execution*
 */
export const ERROR_104 = {
  CODE: '104',
  DATA: {
    CODE: 'ups_error_104',
    type: 'error',
    title: 'No es posible continuar con tu solicitud',
    description: 'Te invitamos a comunicarte con tu <b>ejecutivo de cuenta</b> o acercate a una de nuestras oficinas para brindarte más información.',
    buttonLabel: 'Finalizar',
    buttonAction: '$exit',
  },
};

/**
 * Constante de ERROR_105, Error de éxito
 *
 * *Error_105 constant, Error de éxito*
 */
export const ERROR_105 = {
  CODE: '105',
  DATA: {
    type: 'success',
    title: '¡Ven a tu sucursal más cercana y realiza en pocos pasos este proceso. Código {0}!',
    description: 'Te invitamos a continuar este proceso en una de nuestras sucursales.',
    showLinkOffices: true,
    buttonLabel: 'Salir',
    buttonAction: '$exit',
  },
};

export const ERROR_136 = {
  CODE: '136',
  DATA: {
    type: 'bonding-async',
    title: '¡Estamos terminando de crear tu(s)  nuevo(s) producto(s)',
    description: `En pocos minutos recibirás un correo electrónico y un mensaje de texto con la confirmación
    y los datos de tu(s) producto(s). Nos comunicaremos contigo en caso de ser necesario para ampliar información.`,
    buttonLabel: 'Ver oferta',
    buttonAction: '$nextPrincipality',
    image: 'assets/images/Alerta_Verde_V1.svg',
    specificInfo: {
      title: 'Número de caso',
      value: '{0}',
    },
  },
};

/**
 * Constante de ERROR_143, Vinculación asincróna TC
 *
 * *Error_143 constant, Async binding TC
 */
export const ERROR_143 = {
  CODE: '143',
  DATA: {
    type: 'bonding-async',
    title: '¡Estamos terminando de crear tu nueva tarjeta de crédito!',
    description: `En pocos minutos recibirás un correo electrónico y un mensaje de texto con la confirmación
    y los datos de tu producto. Nos comunicaremos contigo en caso de ser necesario para ampliar información.
    <br/><br/>
    Antes de irte <strong>puedes aprovechar una gran oferta que tenemos para ti</strong>.`,
    buttonLabel: 'Ver oferta',
    buttonAction: '$nextPrincipality',
    image: 'assets/images/Alerta_Verde_V1.svg',
    specificInfo: {
      title: 'Número de caso',
      value: '{0}',
    },
  },
};

/**
 * Constante de ERROR_139, Confirmación CTA
 *
 * Error_139 constant, CTA Confirm
 */
export const ERROR_139 = {
  CODE: '139',
  DATA: {
    type: 'successPrincipality',
    title: '¡Estamos en proceso de crear tu cuenta de ahorros!',
    description: `Recibirás un correo electrónico y un mensaje de texto con la confirmación de creación
    de tu nuevo producto Itaú.
    <br/><br/>
    Descubre todos los beneficios que tienes con tu nueva cuenta de ahorros.
    <br/><br/>
    <a class=\"call-to-action-links\" href=\"https://www.itau.co/sites/default/files/abrecuentas\" target=\"_blank\">Conocer beneficios</a>
    <a class="icon icon-itaufonts_seta_right"></a>`,
    showLinkOffices: true,
    buttonLabel: 'Finalizar',
    buttonAction: '$exit',
    image: 'assets/images/Principalidad.svg',
  },
};

/**
 * Constante de ERROR_107, Error en la ejecución del evento
 *
 * *Error_107 constant, Error on app execution*
 */
export const ERROR_107 = {
  CODE: '107',
  DATA: {
    CODE: 'ups_error_107',
    type: 'error',
    title: 'No es posible continuar con tu solicitud',
    description: 'Te invitamos a comunicarte con tu <b>ejecutivo de cuenta</b> o acercate a una de nuestras oficinas para brindarte más información.',
    buttonLabel: 'Finalizar',
    buttonAction: '$exit',
  },
};

export const ERROR_108 = {
  CODE: '108',
  DATA: {
    type: 'success',
    title: '',
    description: `Ingresa con tu usuario y contraseña,
    si aún no los tienes, dirígete a la pantalla de inicio y créalos en la opción regístrate.`,
    showLinkOffices: true,
    buttonLabel: 'Finalizar',
    buttonAction: '$exit',
  },
};

/**
 * Constante de ERROR_121, Error con los requisitos del producto
 *
 * *Error_121 constant, Error products requirement*
 */
export const ERROR_121 = {
  CODE: '121',
  DATA: {
    CODE: 'Rechazo_PCO',
    type: 'pco_rejection',
    title: 'Tu solicitud no ha sido aprobada',
    description: 'Agradecemos tu confianza en Itaú. Esperamos ofrecerte en una próxima ocasión lo que necesites.',
    buttonLabel: 'Finalizar',
    buttonAction: '$exit',
    image: 'assets/images/document-error.svg',
  },
};

/**
 * Constante de ERROR_401, Error con los permisos de la cámara
 *
 * *Error_401 constant, Error camera permissions*
 */
export const ERROR_401 = {
  CODE: '401',
  DATA: {
    type: 'error',
    title: 'Necesitamos permisos para usar tu cámara',
    description: 'Para poder identificarte, habilita los permisos de la cámara en la configuración de tu dispositivo.',
    showLinkSettings: true,
    buttonLabel: 'Salir',
    buttonAction: '$exit',
  },
};

/**
 * Constante de ERROR_122, Error en la creación de la cuenta
 *
 * *Error_122 constant, Error in account creation*
 */
export const ERROR_122 = {
  CODE: '122',
  DATA: {
    CODE: 'ups_error_122',
    type: 'error',
    title: '{0}, lo sentimos no pudimos crear tu cuenta',
    description: `Contacta a tu asesor o comunícate con nuestra línea de servicio al
      5818181 en Bogotá o al 01 8000 512633 en el resto del país.`,
    buttonLabel: 'Finalizar',
    buttonAction: '$exit',
  },
};

/**
 * Constante de ERROR_122, Error técnico
 *
 * *Error_122 constant, Technical error
 */
export const ERROR_123 = {
  CODE: '123',
  DATA: {
    CODE: 'ups_error_123',
    type: 'errorTecnico',
    title: '{0}, lo sentimos no pudimos crear tu cuenta',
    description: 'Estamos presentando inconvenientes técnicos. Inténtalo de nuevo más tarde.',
    buttonLabel: 'Finalizar',
    buttonAction: '$exit',
    image: 'assets/images/Amarelo.png',
  },
};
/**
 * Constante de ERROR_124, Error de éxito con la confirmación de la cuenta
 *
 * *Error_124 constant, Success error sending account success creation
 */
export const ERROR_124 = {
  CODE: '124',
  DATA: {
    CODE: 'ups_error_124',
    type: 'success',
    title: '¡Tu solicitud fue recibida y la estamos procesando!',
    description: `Recibir\u00E1s en tu correo electr\u00F3nico la informaci\u00F3n de tu cuenta el pr\u00F3ximo
    d\u00EDa h\u00E1bil. En caso de no recibirlo comun\u00EDcate al <strong>581 81 81</strong>
    en Bogot\u00E1 o al <strong>01 8000 512633</strong> en el resto del pa\u00EDs.`,
    buttonLabel: 'Finalizar',
    buttonAction: '$exit',
  },
};

/**
 * Constante de ERROR_125, Error de éxito con la confirmación de la cuenta
 *
 * *Error_125 constant, Success error sending account success creation
 */
export const ERROR_125 = {
  CODE: '125',
  DATA: {
    type: 'success',
    title: '¡Tu solicitud fue recibida y la estamos procesando!',
    description: `Recibirás en tu correo electrónico la confirmación y por mensaje de texto,
     la información de tu producto(s) a mas tardar el próximo dia habil. En caso de no recibirlo
     comunícate al <strong>581 81 81</strong> en  Bogotá o al <strong>01 8000 512633</strong> en el resto del país.`,
    buttonLabel: 'Finalizar',
    buttonAction: '$exit',
  },
};

/**
 * Constante de ERROR_126, Error segmento no valido
 *
 * *Error_126 constant, invalid segment
 */
export const ERROR_126 = {
  CODE: '126',
  DATA: {
    type: 'error',
    title: '{0}, no podemos continuar con tu solicitud',
    description: `Te invitamos a continuar este proceso con tu ejecutivo de banca de empleados.`,
    buttonLabel: 'Finalizar',
    buttonAction: '$exit',
    image: 'assets/images/Amarelo.png',
  },
};

/**
 * Constante de ERROR_127, Error técnico
 *
 * *Error_127 constant, Technical error
 */
export const ERROR_127 = {
  CODE: '127',
  DATA: {
    CODE: 'ups_error_127',
    type: 'error',
    title: '¡Lo sentimos! <br/>No es posible continuar con tu solicitud.',
    description: 'Estamos presentando inconvenientes técnicos. Inténtalo de nuevo más tarde.',
    buttonLabel: 'Finalizar',
    buttonAction: '$exit',
  },
};

/**
 * Constante de ERROR_128, Error informacion desactualizada
 *
 * *Error_128 constant, outdated user info
 * if error add https:// to the link
 */
export const ERROR_128 = {
  CODE: '128',
  DATA: {
    type: 'error',
    title: '!{0}, tus datos están desactualizados!',
    description: `Te invitamos a actualizarlos por medio de nuestros canales:
    <br/> <br/>
    Portal web <a class=\"call-to-action-links\">www.itau.co</a>
    ingresando con tu usuario y contraseña en la opción actualización de datos.
    <br/> <br/>
    Banca telefónica 581 81 81 en Bogotá 01 8000 512633 en el resto del país o en una de nuestras sucursales.`,
    showLinkOffices: true,
    buttonLabel: 'Finalizar',
    buttonAction: '$exit',
  },
};

/**
 * Constante de ERROR_129, proceso en tramite
 *
 * *Error_129 constant, current process
 */
export const ERROR_129 = {
  CODE: '129',
  DATA: {
    type: 'error',
    title: '¡Tienes un proceso en trámite! Debes finalizarlo para obtener un nuevo producto.',
    description: `Enviaremos a tu correo la lista de documentos e instrucciones para continuar
     con la solicitud de tu producto. En caso de no recibirlo, comunícate al 581 81 81 en Bogotá
      o al 01 8000 512633 en el resto del país.`,
    buttonLabel: 'Finalizar',
    buttonAction: '$exit',
    image: 'assets/images/error_image_2.png',
  },
};

/**
 * Constante de ERROR_125, Error de éxito con la confirmación de la cuenta
 *
 * *Error_125 constant, Success error sending account success creation
 */
export const ERROR_130 = {
  CODE: '130',
  DATA: {
    type: 'success',
    title: '¡Tu solicitud fue recibida y la estamos validando!',
    description: `Próximamente uno de nuestros asesores se comunicará contigo.
     Enviaremos a tu correo la lista de documentos e instrucciones para continuar con la solicitud de tu producto.`,
    buttonLabel: 'Finalizar',
    buttonAction: '$exit',
    specificInfo: {
      title: 'Número de solicitud',
      value: '{0}',
    },
  },
};
/**
 * Constante de ERROR_125, Error de éxito con la confirmación de la cuenta
 *
 * *Error_125 constant, Success error sending account success creation
 */
export const ERROR_135 = {
  CODE: '135',
  DATA: {
    type: 'error',
    title: '¡Tienes una solicitud en tramite de este producto!',
    description: `<strong>Debes finalizarla para obtener uno nuevo.</strong> </br></br>
    Si tienes dudas comunícate al 581 81 81 en Bogotá
    o al 01 8000 512633 en el resto del país.`,
    showLinkOffices: true,
    buttonLabel: 'Finalizar',
    buttonAction: '$exit',
  },
};
/**
 * Constante de ERROR_137, Error de zona gris identificacion
 *
 * *Error_137 constant, Success error sending account success creation
 */
export const ERROR_137 = {
  CODE: '137',
  DATA: {
    type: 'zone-grey',
    title: '¡Tu solicitud fue recibida y la estamos validando!',
    description: `Recibirás un correo electrónico y un mensaje de texto con los datos de tu producto o te contactaremos en caso de necesitar información adicional.<br><br>Es necesario que realices un proceso de identificación manual y enviar el resultado al correo: <a class=\"call-to-action-links\">misolicitud@itau.co</a>`,
    showLinkOffices: true,
    buttonLabel: 'Finalizar',
    buttonAction: '$exit',
    image: 'assets/images/Group_5.svg',
    specificInfo: {
      title: 'Número de solicitud',
      value: '{0}',
    },
  },
};
/**
 * Constante de ERROR_138, Vinculación asincróna
 *
 * *Error_137 constant, Async binding
 */
export const ERROR_138 = {
  CODE: '138',
  DATA: {
    CODE: 'ups_error_138',
    type: 'bonding-async',
    title: '¡Estamos terminando de crear tu(s) nuevo producto(s)!',
    description: `En pocos minutos recibirás un correo electrónico y un mensaje de texto con la confirmación
    y los datos de tu(s) producto(s). Nos comunicaremos contigo en caso de ser necesario para ampliar información.`,
    buttonLabel: 'Finalizar',
    buttonAction: '$exit',
    image: 'assets/images/Alerta_Verde_V1.svg',
    specificInfo: {
      title: 'Número de caso',
      value: '{0}',
    },
  },
};
/**
 * Constante de ERROR_500, Error técnico
 *
 * *Error_500 constant, Technical error
 */
export const ERROR_500 = {
  CODE: '500',
  DATA: {
    CODE: 'ups_error_500',
    type: 'error',
    title: 'Oops, lo sentimos algo salió mal :(',
    buttonLabel: 'Salir',
    buttonAction: '$exit',
  },
};

/**
 * Constante de ERROR_501, Error técnico de conexión
 *
 * *Error_501 constant, Technical connection error
 */
export const ERROR_501 = {
  CODE: '501',
  DATA: {
    type: 'error',
    title: 'Presentas fallas de conexión a internet',
    description: 'Te invitamos a revisar tu conexión wi-fi o datos móviles.',
    buttonLabel: 'Finalizar',
    buttonAction: '$exit',
  },
};

export const ERROR_512 = {
  CODE: '512',
  DATA: {
    type: 'error',
    title: '¡Queremos conocerte!',
    showLinkOffices: true,
    description: 'Continúa el proceso en una sucursal, llama en Bogotá al <strong>5818181</strong>, ' +
      'en el resto del país al <strong>01 8000 512633</strong> o con uno de nuestros asesores.',
    buttonLabel: 'Finalizar',
    buttonAction: '$exit',
  },
};

export const ERROR_514 = {
  CODE: '514',
  DATA: {
    type: 'error',
    title: '¡Lo sentimos! <br/>No es posible continuar con tu solicitud.',
    showLinkOffices: true,
    description: 'Ya cuentas con un producto o productos de este tipo. Te invitamos a continuar el proceso en una de nuestras sucursales.',
    buttonLabel: 'Finalizar',
    buttonAction: '$exit',
  },
};

/**
 * Constante de ERROR_502, Error de tiempo de contrato
 *
 * *Error_502 constant, Contract time error
 */
export const ERROR_502 = {
  CODE: '502',
  DATA: {
    type: 'date-error',
    title: '¡Menos de {0} no es suficiente!',
    description: 'Edita la fecha que ingresaste o intenta nuevamente cuando lleves {0} realizando tu actividad',
    buttonLabel: 'Finalizar',
    buttonAction: '$exit',
  },
};

/**
 * Constante de ERROR_503, Error técnico dbs
 *
 * *Error_503 constant, Technical dbs error
 */
export const ERROR_DBS = {
  CODE: 'dsbException',
  DATA: {
    type: 'error',
    title: '¡Queremos conocerte!',
    description: 'Ven a tu sucursal más cercana y realiza en pocos pasos este proceso. &lt;Código {0}&gt;',
    showLinkOffices: true,
    buttonLabel: 'Finalizar',
    buttonAction: '$exit',
  },
};

/**
 * Constante de ERROR_301, ERROR_106, ERROR_512, Error técnico
 *
 * *ERROR_301, ERROR_106, ERROR_512 constant, Technical error
 */
export const ERROR_BRANCH = {
  CODE_1: '301',
  CODE_2: '106',
  CODE_3: '512',
  DATA: {
    type: 'error',
    title: '¡Queremos conocerte!',
    description: `Necesitamos tener unos datos adicionales para abrir tu producto.
      Te invitamos a continuar el proceso en una de nuestras sucursales.`,
    showLinkOffices: true,
    buttonLabel: 'Finalizar',
    buttonAction: '$exit',
  },
};
/**
 * Constante de ERROR_600, Error técnico
 *
 * *ERROR_600, Technical error
 */

// Errrores para la integración del servicio de clientless
export const ERROR_600 = {
  CODE: '600',
  DATA: {
    type: 'clientless',
    title: '¡Queremos conocerte!',
    description: 'Ven a tu sucursal más cercana y realiza en pocos pasos este proceso. Código 600',
    showLinkOffices: false,
    buttonLabel: 'Finalizar',
    buttonAction: '$exit',
  },
};
export const ERROR_601 = {
  CODE: '601',
  DATA: {
    type: 'clientless',
    title: '¡Queremos conocerte!',
    description: 'Ven a tu sucursal más cercana y realiza en pocos pasos este proceso. Código 601',
    showLinkOffices: false,
    buttonLabel: 'Finalizar',
    buttonAction: '$exit',
  },
};
export const ERROR_602 = {
  CODE: '602',
  DATA: {
    type: 'clientless',
    title: '¡Queremos conocerte!',
    description: 'Ven a tu sucursal más cercana y realiza en pocos pasos este proceso. Código 602',
    showLinkOffices: false,
    buttonLabel: 'Finalizar',
    buttonAction: '$exit',
  },
};
export const ERROR_603 = {
  CODE: '603',
  DATA: {
    type: 'clientless',
    title: '¡Queremos conocerte!',
    description: 'Ven a tu sucursal más cercana y realiza en pocos pasos este proceso. Código 603',
    showLinkOffices: false,
    buttonLabel: 'Finalizar',
    buttonAction: '$exit',
  },
};
// El código 400 corresponde al error 401 respondido por el servicio de clientless
// El código 402 corresponde a la respuesta 500 que devuelve el servicio de clientless
export const ERROR_NONE = {
  CODE: 'None',
  DATA: {
    type: 'clientless',
    title: '¡Queremos conocerte!',
    description: 'Ven a tu sucursal más cercana y realiza en pocos pasos este proceso. Código None',
    showLinkOffices: false,
    buttonLabel: 'Finalizar',
    buttonAction: '$exit',
  },
};

export const ERROR_404 = {
  CODE: '404',
  DATA: {
    type: 'clientless',
    title: '¡Queremos conocerte!',
    description: 'Ven a tu sucursal más cercana y realiza en pocos pasos este proceso. Código 404',
    showLinkOffices: false,
    buttonLabel: 'Finalizar',
    buttonAction: '$exit',
  },
};
export const ERROR_403 = {
  CODE: '403',
  DATA: {
    type: 'clientless',
    title: '¡Queremos conocerte!',
    description: 'Ven a tu sucursal más cercana y realiza en pocos pasos este proceso. Código 403',
    showLinkOffices: false,
    buttonLabel: 'Finalizar',
    buttonAction: '$exit',
  },
};
/**
 * Constante de ERROR_131, consulta no disponible
 *
 * *Error_131 constant, non avaliable request
 */
export const ERROR_131 = {
  CODE: '131',
  DATA: {
    type: 'error',
    title: 'Lo sentimos, no está disponible esta consulta',
    description: `Estamos presentando inconvenientes técnicos. Inténtalo de nuevo más tarde.`,
    buttonLabel: 'Finalizar',
    buttonAction: '$exit',
  },
};

export const ERROR_400 = {
  CODE: '400',
  DATA: {
    type: 'clientless',
    title: '¡Queremos conocerte!',
    description: 'Ven a tu sucursal más cercana y realiza en pocos pasos este proceso. Código 401',
    showLinkOffices: false,
    buttonLabel: 'Finalizar',
    buttonAction: '$exit',
  },
};
export const ERROR_402 = {
  CODE: '402',
  DATA: {
    type: 'clientless',
    title: '¡Queremos conocerte!',
    description: 'Ven a tu sucursal más cercana y realiza en pocos pasos este proceso. Código 500',
    showLinkOffices: false,
    buttonLabel: 'Finalizar',
    buttonAction: '$exit',
  },
};
export const ERROR_TECH = {
  CODE: 'tech',
  DATA: {
    type: 'clientless',
    title: '¡Lo sentimos! En el momento estamos presentando inconvenientes técnicos',
    description: 'Por favor, inténtalo más tarde',
    showLinkOffices: false,
    buttonLabel: 'Finalizar',
    buttonAction: '$exit',
  },
};
/**
 * Constante de ERROR_132, solicitud caducada
 *
 * *Error_132 constant, expired request
 */
export const ERROR_132 = {
  CODE: '132',
  DATA: {
    type: 'error',
    title: 'Tu solicitud caducó',
    description: `El tiempo de vigencia de tu solicitud caducó.
      Te invitamos a realizar una nueva solicitud de productos de crédito.`,
    buttonLabel: 'Finalizar',
    buttonAction: '$exit',
  },
};
export const ERROR_133 = {
  CODE: '133',
  DATA: {
    type: 'error',
    title: '¡Lo sentimos! No fue posible validar tu identidad',
    description: 'Radica el caso por el proceso tradicional, estamos trabajando para habilitar este tipo de solicitud por el canal digital.',
    showLinkOffices: true,
    buttonLabel: 'Finalizar',
    buttonAction: '$exit',
  },
};

export const ERROR_LIB = {
  CODE: 'LIBERROR',
  DATA: {
    type: 'loan',
    title: '¡Lo sentimos! No es posible continuar con tu solicitud de Libranza',
    description: 'Si deseas un producto diferente a Crédito de Libranza te invitamos a realizar una nueva solicitud.',
    showLinkOffices: false,
    buttonLabel: 'Finalizar',
    buttonAction: '$exit',
  },
};
/**
 * Constante de ERROR_140, cliente existente
 *
 * *Error_140 constant, client exist
 */
export const ERROR_140 = {
  CODE: '140',
  DATA: {
    type: 'error',
    title: 'Ya te encuentras registrado',
    description: `Para hacer esta consulta te invitamos a ingresar con tu usuario y contraseña.`,
    buttonLabel: 'Salir',
    buttonAction: '$exit',
  },
};

/**
 * Constante de ERROR_141, Error sin solicitudes encontradas
 *
 * *Error_141 constant, No requests
 */
export const ERROR_141 = {
  CODE: '141',
  DATA: {
    type: 'info',
    title: 'Consulta de solicitudes',
    description: `Hasta el momento no tienes solicitudes pendientes.`,
    buttonLabel: 'Volver',
    buttonAction: '$exit',
    image: 'assets/images/folder.svg',
  },
};

/**
 * Constante de ERROR_141, Error sin solicitudes encontradas
 *
 * *Error_141 constant, No requests
 */
export const ERROR_142 = {
  CODE: '142',
  DATA: {
    type: 'error',
    title: 'Lo sentimos, no está disponible esta consulta',
    description: `No se encuentra información del caso que esta consultando.`,
    buttonLabel: 'Finalizar',
    buttonAction: '$exit',
  },
};

/*
 * Constante de ERROR_134, Error en la validación cantidad maxima de productos
 *
 * *Error_134 constant, Error validating max count products*
 */
export const ERROR_134 = {
  CODE: '134',
  DATA: {
    type: 'error',
    title: '¡Lo sentimos! Estos productos no pueden continuar en tu solicitud',
    description: `<strong>¿Deseas continuar tu proceso con los demás productos?</strong>`,
    buttonLabel: 'Continuar',
    buttonAction: '$next',
    image: 'assets/images/Amarelo.png',
  },
};

export const ERROR_999 = {
  CODE: '999',
  DATA: {
    type: 'warningDisplay',
    title: 'En Itaú mejoramos para tí',
    description: `Estamos realizando una actualización del sistema, y muy pronto podrás vivir una nueva experiencia.<br><br>
    Si deseas solicitar un producto diligencia el formulario y uno de nuestros asesores se comunicará contigo.`,
    buttonLabel: 'Ir al formulario',
    buttonAction: '$nextWarningDisplay',
  },
};

export const ERROR_0104 = {
  CODE: '0104',
  DATA: {
    CODE: 'ups_error_pco',
    type: 'error',
    title: 'No es posible continuar con tu solicitud',
    description: 'Te invitamos a comunicarte con tu <b>ejecutivo de cuenta</b> o acercate a una de nuestras oficinas para brindarte más información.',
    buttonLabel: 'Finalizar',
    buttonAction: '$exit',
  },
};
